export type PermissionScope = 'NATIONAL' | 'DISTRICT' | 'REGION';

export interface PermissionGrant {
  code: string;
  scope: PermissionScope;
  district_id: string | null;
  region_id: string | null;
}

/** Territory of the record being acted on. Omit it to ask "does the user hold this anywhere?" */
export interface PermissionTarget {
  districtId?: string | null;
  regionId?: string | null;
}

/**
 * Same rules as public.has_permission(): NATIONAL passes everywhere, DISTRICT on rows of its
 * district, REGION on rows of its region; a national row (no district, no region) needs NATIONAL.
 * A region-only target is not resolved to its district here (no territory lookup on the client).
 */
export function grantsPermission(
  grants: readonly PermissionGrant[],
  code: string,
  target?: PermissionTarget,
): boolean {
  const matching = grants.filter((g) => g.code === code);
  if (!target) return matching.length > 0;
  return matching.some(
    (g) =>
      g.scope === 'NATIONAL' ||
      (g.scope === 'DISTRICT' && !!target.districtId && g.district_id === target.districtId) ||
      (g.scope === 'REGION' && !!target.regionId && g.region_id === target.regionId),
  );
}
